/* eslint-disable no-dupe-keys */
export default {
  order_statistics: {
    titles: {
      // 统计面板
      overview: '综合概览',
      dashboard: '订单统计面板',
      time_group_statistics: '按时间统计',
      export_time_group_statistics: '按时间统计的订单数据',
      time_group_order_amount_statistics: '近十天订单金额统计',
      time_group_order_count_statistics: '近十天订单数量统计',
      station_prop_group_order_amount_statistics: '近十天电站的订单金额统计',
      station_prop_group_order_count_statistics: '近十天电站的订单数量统计',
      // 按时间分组统计
      latest_days_order_amount: '订单金额 (元)',
      latest_days_order_count: '订单数 (单)',
      statistics_net_income_amount: '预计净收入(元)',
      statistics_orders_amount: '订单金额统计',
      statistics_orders_count: '订单数统计',
      statistics_users_count: '用户数统计',
      statistics_orders_balance_pay_amount: '余额支付金额统计',
      statistics_orders_group_balance_pay_amount: '资金池支付金额统计',
      // 按属性分组统计
      statistics_orders_payable_amount: '应付金额统计',
      statistics_orders_discount_amount: '优惠金额统计',
      statistics_orders_service_amount: '服务费统计',
      statistics_consumed_power: '电量统计',
      statistics_gun_average_porwer: '单枪平均电量统计(以当前枪口数估算)'
    },
    legends: {
      net_income_amount: '预计净收入(元)',
      sharing_amount: '预计渠道分成(元)',
      orders_amount: '订单金额(元)',
      balance_pay_amount: '余额支付金额(元)',
      group_balance_pay_amount: '资金池支付金额(元)',
      orders_count: '充电数(单)',
      gun_average_porwer: '单枪平均电量(度)',
      users_count: '用户数(人)',
      orders_payable_amount: '应付金额(元)',
      orders_discount_amount: '订单优惠金额(元)',
      merchant_discount_amount: '商家让利(元)',
      platform_discount_amount: '平台补贴(元)',
      orders_service_amount: '订单服务费(元)',
      sharp_peak_service_amount: '尖服务费(元)',
      peak_service_amount: '峰服务费(元)',
      flat_service_amount: '平服务费(元)',
      valley_service_amount: '谷服务费(元)',
      orders_charge_amount: '订单电费(元)',
      sharp_peak_charge_amount: '尖电费(元)',
      peak_charge_amount: '峰电费(元)',
      flat_charge_amount: '平电费(元)',
      valley_charge_amount: '谷电费(元)',
      consumed_power: '订单电量(度)',
      sharp_peak_consumed_power: '尖电量(度)',
      peak_consumed_power: '峰电量(度)',
      flat_consumed_power: '平电量(度)',
      valley_consumed_power: '谷电量(度)',
      discount_consumed_power: '充电包优惠电量(度)',
      charging_package_power_price: '充电包电量售价(元/度)',
      max_power: '站总功率(千瓦)',
      amount_for_power: '每千瓦收入(元)'
    },
    labels: {
      group_by: '统计项',
      charging_finished_at: '充电结束时间',
      order_bill_end_time: '分时结束时间',
      service_provider: '运营商',
      ev_charging_station: '充电站',
      user: '用户',
      order_source_type: '订单来源',
      time_type: '时间类型'
    },
    placeholder: {
      select_order_source_type: 'ECMP/互联互通',
      select_time_type: '尖/峰/平/谷'
    },
    btn: {
      more: '查看更多'
    },
    // 分组类型
    group_types: {
      station: '按充电站'
    },
    discount_types: {
      group: '集团',
      coupon: '优惠券',
      charging_package: '充电包'
    },
    time_types: {
      sharp_peak: '尖',
      peak: '峰',
      flat: '平',
      valley: '谷',
      unknown: '未知'
    },
    tips: {
      statistics_scope: '只统计已支付，并且应付金额大于0元的订单',
      discount_amount: '基于「时间类型」的统计，无法获取优惠信息'
    }
  }
}
